module.exports = __webpack_public_path__ + "static/media/blog-post-01.e2303a3b.jpg";